export const sortDropdownOptions = [
  {
    label: "common.sortByNameAsc",
    sort: {
      name: "ASC",
    },
  },
  {
    label: "common.sortByNameDesc",
    sort: {
      name: "DESC",
    },
  },
  {
    label: "common.sortByPriceLow",
    sort: {
      price: "ASC",
    },
  },
  {
    label: "common.sortByPriceHigh",
    sort: {
      price: "DESC",
    },
  },
];
